// extracted by mini-css-extract-plugin
export default {"app":"_39ZJQ","roundedBorders":"_1moXP"};